module.exports = __webpack_public_path__ + "img/radiacion.88c5689d.png";